import { Fragment, ReactElement } from 'react';
import DetailNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/detail';

const DetailNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <DetailNotificationsCivilStatusShared />
    </Fragment>
  );
};

DetailNotificationsCivilStatusPage.displayName = 'Detail Notifications Civil Status component';

export default DetailNotificationsCivilStatusPage;
